import React from 'react';
import './App.css';

import Cancion from './components/canciones';

function App() {
  return (
    <div className="App">
       <Cancion />
    </div>
  );
}

export default App;
